import styled from 'styled-components';
import { Paper } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';

export const StyledPaper = styled(Paper)`
  margin: 1em 0;
  min-height: 90px;
  display: flex;
  flex-direction: column;
  padding: 12px;
`;

export const AppDetails = styled.span``;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px; 
  color: rgba(0, 0, 0, 0.54);

  ${AppDetails} {
    font-size: 12px;
  }
`;

const StyledSpan = styled.span`
  display: flex;
  font-size: 13px;
  text-align: left;
`;

export const TitleText = styled(StyledSpan)`
  font-weight: bold;
`;

export const MessageText = styled(StyledSpan)`
  color: #2d2d2d;
`;

export const StyledNotificationsIcon = styled(NotificationsIcon)`
  font-size: 16px !important;
  margin-right: 0.25em !important;
`;
